export const GET_BULK_WEIGHT_DISCREPANCY_COUNT_SUCCESS = "GET_BULK_WEIGHT_DISCREPANCY_COUNT_SUCCESS";
export const GET_BULK_WEIGHT_DISCREPANCY_COUNT_REQUEST = "GET_BULK_WEIGHT_DISCREPANCY_COUNT_REQUEST";
export const GET_BULK_WEIGHT_DISCREPANCY_COUNT_FAILURE = "GET_BULK_WEIGHT_DISCREPANCY_COUNT_FAILURE";
export const GET_BULK_WEIGHT_DISCREPANCY_COUNT_RESET = "GET_BULK_WEIGHT_DISCREPANCY_COUNT_RESET";
export const getBulkWeightDiscrepancyCountSuccess = (payload) => ({
    type: GET_BULK_WEIGHT_DISCREPANCY_COUNT_SUCCESS,
    payload,
});
export const getBulkWeightDiscrepancyCountRequest = (payload) => ({
    type: GET_BULK_WEIGHT_DISCREPANCY_COUNT_REQUEST,
    payload,
});
export const getBulkWeightDiscrepancyCountFailure = (payload) => ({
    type: GET_BULK_WEIGHT_DISCREPANCY_COUNT_FAILURE,
    payload,
});
export const getBulkWeightDiscrepancyCountReset = () => ({
    type: GET_BULK_WEIGHT_DISCREPANCY_COUNT_RESET,
});
